import { render, staticRenderFns } from "./StatsChatPanel.vue?vue&type=template&id=71feb82a&scoped=true"
import script from "./StatsChatPanel.vue?vue&type=script&lang=js"
export * from "./StatsChatPanel.vue?vue&type=script&lang=js"
import style0 from "./StatsChatPanel.vue?vue&type=style&index=0&id=71feb82a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71feb82a",
  null
  
)

export default component.exports